<ion-header class="ion-no-border" color="light">
  <ion-toolbar>
    <ion-title>Seleccionar parada</ion-title>
    <ion-buttons slot="start">
      <ion-button (click)="closeModal()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
  <ion-toolbar>
    <ion-row>
      <ion-col>
        <ion-select
          [(ngModel)]="zone"
          placeholder="Zona"
          [compareWith]="zoneCompare"
          #B
          (ionChange)="selectZone(B.value)"
        >
          <ion-select-option [value]="z" *ngFor="let z of zones; let i = index">{{ z.name }}</ion-select-option>
        </ion-select>
      </ion-col>
      <ion-col>
        <ion-select
          [(ngModel)]="route"
          placeholder="Ruta"
          [compareWith]="routeCompare"
          #R
          (ionChange)="selectRoute(R.value)"
        >
          <ion-select-option [value]="r" *ngFor="let r of routes; let i = index">{{ r.name }}</ion-select-option>
        </ion-select>
      </ion-col>
    </ion-row>
  </ion-toolbar>
  <ion-toolbar *ngIf="searchTerm || (filteredStops && filteredStops.length > 5)">
    <ion-searchbar
      animated
      clearIcon
      color="light"
      [(ngModel)]="searchTerm"
      (ionInput)="setFilteredStops()"
    ></ion-searchbar>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-padding">
  <p *ngIf="!filteredStops && !loading">Seleccionar zona y/o ruta.</p>
  <ion-list *ngIf="!filteredStops && loading">
    <ion-item *ngFor="let stop of [0, 1, 2, 3, 4, 5]" lines="full">
      <ion-thumbnail slot="start">
        <ion-skeleton-text animated></ion-skeleton-text>
      </ion-thumbnail>
      <ion-label>
        <ion-skeleton-text animated style="width: 60%"></ion-skeleton-text>
        <ion-skeleton-text animated style="width: 40%"></ion-skeleton-text>
      </ion-label>
    </ion-item>
  </ion-list>
  <ion-list>
    <ion-item *ngFor="let stop of filteredStops" lines="full" (click)="select(stop)">
      <ion-thumbnail slot="start" *ngIf="stop.image || route?.image">
        <ion-img class="photo" [src]="stop.image" *ngIf="stop.image"></ion-img>
        <ion-img class="photo" [src]="route?.image" *ngIf="!stop.image && route?.image"></ion-img>
      </ion-thumbnail>
      <ion-label>
        {{ stop.name }}
        <br />
        <span *ngIf="stop.radial && stop.radial.name">{{ stop.radial.name }}</span>
      </ion-label>
      <ion-button fill="clear" slot="end">
        <ion-icon name="arrow-forward"></ion-icon>
      </ion-button>
    </ion-item>
  </ion-list>
</ion-content>
